import {PolymerElement} from '@polymer/polymer/polymer-element.js';
import { ConfigService } from '@nuskin/ns-util';
import { getConfiguration } from '@nuskin/configuration-sdk';

/**
 * @customElement
 * @polymer
 */
export class MySiteAdminRedirection extends PolymerElement {

    static get is() {
        return 'mysite-admin-redirection';
    }

    constructor() {
        super();
    }

    /**
     * Checks Contentstack for current market and redirects to new admin if enabled
     */
    async checkMarketInContentstack(marketCode) {
        const config = ConfigService.getMarketConfig();
        try {
            const response = await getConfiguration(
                ['nextgenMysite'],
                {
                    country: marketCode,
                    clientId: config.checkout.clientId
                }
            );
            console.log("Contentstack response:", response);
            return response && response.nextgenMysite ? response.nextgenMysite : null;
        } catch (err) {
            console.error('Contentstack call failed:', err);
            return null;
        }
    }

    handleRedirection(nextgenMysite, marketCode, language) {
        const languageMacroName = "<LANGUAGE>";
        const countryMacroName = "<COUNTRY>";
        let url = nextgenMysite.mysiteAdminUrl;

        url = url.replace(languageMacroName, language)
            .replace(countryMacroName, marketCode);
            
        // Open the constructed URL in the same page
        window.open(url, '_self');
    }
}

window.customElements.define(MySiteAdminRedirection.is, MySiteAdminRedirection);